import React from 'react';
import { AssessmentContext } from './assessmentContext';

export const useAssessmentType = () => React.useContext(AssessmentContext);